import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var LayersSVG = function LayersSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    d: "M3 11.73l11.94 7.39a2.09 2.09 0 002.22 0l11.94-7.39a2 2 0 00-.1-3.4L17 1.76a2.13 2.13 0 00-2 0L3 8.33a2 2 0 000 3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.47 15.32L16 23 3.61 15.27A1 1 0 102.51 17l12.38 7.7a2.09 2.09 0 002.22 0L29.52 17a1 1 0 00.31-1.41 1 1 0 00-1.36-.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.47 20.8L16 28.51 3.61 20.75a1 1 0 00-1.1 1.77l12.38 7.66a2.09 2.09 0 002.22 0l12.41-7.67a1 1 0 00.31-1.41 1 1 0 00-1.36-.3z"
  }));
};
LayersSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LayersSVG);